import cn from 'classnames';
import React, {FC} from 'react';

import * as localizationKeys from '../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import routerService from '../../services/routerService';
import {ButtonRaw} from '../Button';
import {IButton} from '../Button/ButtonTypes';
import {ArrowLeftIcon} from '../Icons';

interface IProps extends IButton {
    ariaLabel?: string;
    testId?: string;
    onClick?: () => void;
    className?: string;
    isWhite?: boolean;
}

const BackButton: FC<IProps> = (props: IProps) => {
    const {className, onClick = routerService.goBack, alt, ...restProps} = props;
    const localizedStrings = getLocalizedStrings();
    const altResult = alt || localizedStrings[localizationKeys.GLOBAL_BACK_BUTTON_TEXT];

    return (
        <div className={cn('flex w-full justify-start px-5', className)}>
            <ButtonRaw
                onClick={onClick}
                className='flex h-12 w-12 items-center justify-center'
                ariaLabel={altResult}
                {...restProps}
            >
                <ArrowLeftIcon className='rtl:rotate-180' />
            </ButtonRaw>
        </div>
    );
};

export default BackButton;
